import Palette from './shared/palette.js';
import typography from './shared/typography.js';
import brandColors from './shared/brandColors.js';
import { shadows, spacers, borderRadius, semanticColors } from './types.js';

const lightBaseTheme = {
    name: 'light',
    palette: Palette,
    shadows,
    spacers,
    borderRadius,
    typography,
    brandColors,
    colors: {
        ...semanticColors,
        Foreground: 'rgba(51, 51, 51, 1)',
        Background: 'rgba(255, 255, 255, 1)',
        ElementBackground: 'rgba(255, 255, 255, 1)',
        HoverBackground: 'rgba(255, 255, 255, 1)',
        BusinessBlue: 'rgba(10, 24, 73, 1)',
        'Level 1': 'rgba(51, 51, 51, 0.07)',
        'Level 2': 'rgba(51, 51, 51, 0.15)',
        'Level 3': 'rgba(51, 51, 51, 0.25)',
        'Level 4': 'rgba(51, 51, 51, 0.5)',
        'Level 5': 'rgba(51, 51, 51, 0.75)',
        Color1: Palette.torchRed[100],
        Color1_75: Palette.torchRed[75],
        Color1_50: Palette.torchRed[50],
        Color1_25: Palette.torchRed[25],
        Color1_15: Palette.torchRed[15],
        Color1_07: Palette.torchRed[7],
        Color2: Palette.electricBlue[100],
        Color2_75: Palette.electricBlue[75],
        Color2_50: Palette.electricBlue[50],
        Color2_25: Palette.electricBlue[25],
        Color2_15: Palette.electricBlue[15],
        Color2_07: Palette.electricBlue[7],
        primary: Palette.torchRed[100],
        secondary: Palette.grey[100],
        positive: Palette.broccoli[100],
        caution: Palette.yolk[100],
        negative: Palette.tomato[100],
        primaryBackground: Palette.torchRed[7],
        secondaryBackground: Palette.grey[7],
        positiveBackground: Palette.broccoli[15],
        cautionBackground: Palette.yolk[15],
        negativeBackground: Palette.tomato[7],
    },
};
var lightBaseTheme$1 = lightBaseTheme;

export { lightBaseTheme$1 as default };
